import { map } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';

@Injectable()
export class BookmarkAuthorFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Lazy Selectors">

  nodeBookmarked$ = (id: string) => this.store.select(FlatStates.BookmarkAuthorState.nodeBookmarked$).pipe(map(filterFn => filterFn(id)));

  //</editor-fold>

  //<editor-fold desc="Requests">

  requestToggleNode(node: FlatModels.NodeEntityModels.NodeEntityType,
                    page: FlatModels.PageEntityModels.PageEntityType) {
    return this.store.dispatch(new FlatActions.BookmarkAuthorActions.ToggleNode(node, page));
  }

  //</editor-fold>

}
